import { connect } from "react-redux";
import PropTypes from "prop-types";

import BaseInputComponent from "basecomponents/BaseInputComponent";
import { InputField, CheckField } from "../components/form";
import { SmallSpinner } from "../components/loaders";

import { hideModal } from "../utils/domUtils";
import {
  removeNullProperties,
  joinObjects,
  objectIsEmpty,
} from "../utils/jsonUtils";
import {
  getPrivilegesFromObject,
  getObjectFromPrivileges,
} from "../utils/userUtils";

import { updateUser, setEditUserFromFunction } from "../actions/userActions";

class AdminEditUserModal extends BaseInputComponent {
  modal_id = "modal_edit_user";

  state = {
    id: null,
    name: "",
    email: "",
    user: "",
    password: "",
    is_active: true,
    is_verified: false,
    // Privilegios
    is_admin: false,
    is_packages: false,
    is_articles: false,
    is_clients: false,
    is_users: false,
    //
    information_setted: false,
    prevent_set_state: false,
    errors: {},
  };

  static getDerivedStateFromProps(nextProps, currentState) {
    let newState = {
      errors: null,
      changed: false,
    };
    if (nextProps.errors) {
      newState.errors = nextProps.errors;
      newState.changed = true;
    }

    if (
      !objectIsEmpty(nextProps.user.item) &&
      !currentState.information_setted &&
      !currentState.prevent_set_state
    ) {
      const privileges = getObjectFromPrivileges(
        nextProps.user.item.privileges
      );
      newState = joinObjects(newState, privileges);
      newState = joinObjects(newState, nextProps.user.item);
      newState["information_setted"] = true;
    }

    if (!newState.changed) return null;

    return removeNullProperties(newState);
  }

  isLoading(): boolean {
    // @ts-ignore
    return this.props.user.loadingOperation;
  }

  onAcceptClick = () => {
    const { id, user, email, name, password, is_active, is_verified } =
      this.state;

    // @ts-ignore
    this.props.updateUser(
      {
        id,
        name,
        email,
        user,
        password,
        is_active,
        is_verified,
        privileges: getPrivilegesFromObject(this.state),
      },
      (success) => {
        if (!success) return;

        this.onCancelClick();
      }
    );
  };

  clearForm = () => {
    this.setState(
      {
        id: null,
        name: "",
        email: "",
        user: "",
        password: "",
        is_active: true,
        is_verified: false,
        // Privilegios
        is_admin: false,
        is_packages: false,
        is_articles: false,
        is_clients: false,
        is_users: false,
        information_setted: false,
        prevent_set_state: true,
        errors: {},
      },
      () => {
        this.setState({ prevent_set_state: false });
      }
    );
  };

  onCancelClick = () => {
    // @ts-ignore
    this.props.setEditUserFromFunction(null);
    this.clearForm();
    hideModal(this.modal_id);
  };

  getForm = () => {
    const {
      user,
      email,
      name,
      password,
      is_active,
      is_verified,
      errors,
      // Privilegios
      is_admin,
      is_packages,
      is_articles,
      is_clients,
      is_users,
    } = this.state;
    const loading = this.isLoading();
    return (
      <>
        <div className="grid-2-col">
          <InputField
            id="edit_name"
            name="name"
            value={name}
            label="Nombre"
            error={errors}
            onChange={this.onChangeTextInput}
          />
          <InputField
            id="edit_email"
            name="email"
            value={email}
            label="Correo"
            error={errors}
            type="email"
            onChange={this.onChangeTextInput}
          />
        </div>

        <div className="grid-2-col">
          <InputField
            id="edit_user"
            name="user"
            value={user}
            label="Nombre de usuario"
            placeholder="Opcional"
            error={errors}
            onChange={this.onChangeTextInput}
          />
          <InputField
            id="edit_password"
            name="password"
            value={password}
            label="Clave"
            error={errors}
            onChange={this.onChangeTextInput}
            type="password"
          />
        </div>

        <div className="grid-2-col form-row">
          <CheckField
            id="edit_is_active"
            name="is_active"
            label="Activo"
            checked={is_active}
            onChange={this.onChangeCheckField}
            error={errors}
          />

          <CheckField
            id="edit_is_verified"
            name="is_verified"
            label="Verificado"
            checked={is_verified}
            onChange={this.onChangeCheckField}
            error={errors}
          />
        </div>

        <div>
          <span className="form-row-title">Privilegios</span>
          <div className="grid-2-col form-row">
            <CheckField
              id="edit_is_admin"
              name="is_admin"
              label="Administrador"
              checked={is_admin}
              onChange={this.onChangeCheckField}
              error={errors}
            />

            <CheckField
              id="edit_is_packages"
              name="is_packages"
              label="Paquetes"
              checked={is_packages}
              onChange={this.onChangeCheckField}
              error={errors}
            />
          </div>
          <div className="grid-2-col form-row">
            <CheckField
              id="edit_is_articles"
              name="is_articles"
              label="Articulos"
              checked={is_articles}
              onChange={this.onChangeCheckField}
              error={errors}
            />
            <CheckField
              id="edit_is_clients"
              name="is_clients"
              label="Clientes"
              checked={is_clients}
              onChange={this.onChangeCheckField}
              error={errors}
            />
          </div>

          <div className="grid-2-col form-row">
            <CheckField
              id="edit_is_users"
              name="is_users"
              label="Usuarios"
              checked={is_users}
              onChange={this.onChangeCheckField}
              error={errors}
            />
          </div>
        </div>

        {loading && <SmallSpinner center={true} />}
      </>
    );
  };

  render() {
    return (
      <div
        className="modal fade"
        id={this.modal_id}
        role="dialog"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Editar usuario</h5>
            </div>
            <div className="modal-body">{this.getForm()}</div>
            <div className="modal-footer">
              <div className="flex-2-separated">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={this.onCancelClick}
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.onAcceptClick}
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// @ts-ignore
AdminEditUserModal.propTypes = {
  user: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  updateUser: PropTypes.func.isRequired,
  setEditUserFromFunction: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  updateUser,
  setEditUserFromFunction,
})(AdminEditUserModal);
